import React from 'react';
import styles from '../../assets/styles/styles.less';
import MediaQuery from 'react-responsive';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { hashHistory } from 'react-router';

import ReviewMobile from './ReviewMobile';
import ConfirmationMobile from './ConfirmationMobile';
import SuccessMobile from './SuccessMobile';
import BummerMobile from './BummerMobile';

import { submitDonation, resetState } from '../../actions/actions.js';


class Review extends React.Component {
	
    componentWillMount(){
        const {reducer} = this.props;
        if (!reducer
        || Object.keys(reducer.charity).legth === 0
        || !reducer.target.valid 
        || !reducer.personal.valid
        || !reducer.payment.valid) hashHistory.push('/');
    }

    render() {
        const { success, error, isResponse, isMatched } = this.props.reducer;
        return (
            <div>
                {(() => {
                    if (!success) {
                        return <ReviewMobile {...this.props} />
                    } else {
                        if (!isResponse) {
                            return isMatched ? <SuccessMobile {...this.props} /> : <ConfirmationMobile {...this.props} />
                        } else {
                            return isMatched ? <SuccessMobile {...this.props} /> : <BummerMobile {...this.props} />
                        }
                    }
                })()}
            </div> 
        )
    }

};

function mapStateToProps(state) {
  return {
    reducer: state.detailsReducer
  }
};

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    submitDonation,
    resetState
}, dispatch)
};

export default connect(mapStateToProps, matchDispatchToProps)(Review);


// WEBPACK FOOTER //
// ./components/Review/Review.js